import { Mail, Send } from "lucide-react";
import React, { useState } from "react";
import { NotificationChannel } from "../../../core/models/notification";
import { UsersFilterShape } from "../../../core/models/user";
import { Button } from "../../../core/components/Button";
import { Card } from "../../../core/components/Card";
import { EmailNotificationComposer } from "./EmailNotificationComposer";
import { FilterSummary } from "./FilterSummary";
import "./NotificationSender.css";
import { SentNotificationsPanel } from "./SentNotificationsPanel";
import { TelegramNotificationComposer } from "./TelegramNotificationComposer";

interface NotificationSenderProps {
    className?: string;
    filter?: UsersFilterShape;
}

export const NotificationSender: React.FC<NotificationSenderProps> = ({ className = "", filter }) => {
    const [channel, setChannel] = useState<NotificationChannel>("TELEGRAM");

    return (
        <Card className={`notification-sender ${className}`}>
            <div className="notification-sender-header">
                <h3>Отправка уведомлений</h3>
            </div>

            <FilterSummary filter={filter} title="Уведомления будут отправлены пользователям с фильтром:" />

            <div className="notification-channel-tabs">
                <Button
                    type="button"
                    variant={channel === "TELEGRAM" ? "primary" : "secondary"}
                    onClick={() => setChannel("TELEGRAM")}
                    icon={<Send size={16} />}
                >
                    Telegram
                </Button>
                <Button
                    type="button"
                    variant={channel === "EMAIL" ? "primary" : "secondary"}
                    onClick={() => setChannel("EMAIL")}
                    icon={<Mail size={16} />}
                >
                    Email
                </Button>
            </div>

            <div className="notification-form-area">
                {channel === "TELEGRAM" ? (
                    <TelegramNotificationComposer filter={filter} />
                ) : (
                    <EmailNotificationComposer filter={filter} />
                )}
            </div>

            <SentNotificationsPanel />
        </Card>
    );
};
